<div class="payment-portal" *ngIf="orderForm" [formGroup]="orderForm">
  <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" class="financial-layout">
    <div fxFlex class="financial-main">

  <div class="payment-block" *ngIf="availableCredit > 0">
    <div class="summary-title">AVAILABLE CREDIT</div>
    <p>
      {{ patient?.lastName }}, {{ patient?.firstName }} — ${{ formatMoney(availableCredit) }}
    </p>
    <button mat-stroked-button type="button" [disabled]="busy || !canPay" (click)="applyCredit()">
      APPLY CREDIT
    </button>
    <mat-form-field style="width:100%">
      <mat-label>TRANSFER CREDIT TO PATIENT ID</mat-label>
      <input matInput [(ngModel)]="transferPatientId" [ngModelOptions]="{standalone: true}" autocomplete="off">
    </mat-form-field>
    <mat-form-field style="width:100%">
      <mat-label>TRANSFER AMOUNT</mat-label>
      <span matPrefix>$&nbsp;</span>
      <input matInput [(ngModel)]="transferAmount" [ngModelOptions]="{standalone: true}" autocomplete="off">
    </mat-form-field>
    <button mat-button type="button" [disabled]="busy" (click)="transferCredit()">TRANSFER CREDIT</button>
  </div>

  <div class="payment-block">
    <mat-form-field style="width:100%">
      <mat-label>DISCOUNT / PROMO</mat-label>
      <mat-select formControlName="discountId">
        <mat-option value="">NONE</mat-option>
        <mat-option *ngFor="let discount of discounts" [value]="discount._id" [disabled]="discount.active === false">
          {{ discount.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field style="width:100%">
      <mat-label>REQUESTED COMPLETION DATE</mat-label>
      <input matInput type="date" formControlName="requestedCompletionDate">
    </mat-form-field>
  </div>

  <div class="payment-block" *ngIf="!acknowledged">
    <div class="summary-title">CUSTOMER ORDER ACKNOWLEDGMENT</div>
    <p class="ack-language">{{ ackLanguage }}</p>
    <p class="ack-note" *ngIf="orderForm.get('requestedCompletionDate')?.value">
      Requested completion date is a customer request and is not an unconditional guarantee.
    </p>
    <button
      type="button"
      class="signature-pad signature-pad-trigger"
      (click)="openAckOverlay()"
    >
      CLICK TO SIGN
    </button>
  </div>
  <div class="payment-block" *ngIf="acknowledged">
    <div class="summary-title">ORDER ACKNOWLEDGED</div>
    <p>{{ orderForm.get('acknowledgedAt')?.value | date:'short' }}</p>
  </div>

  <div class="payment-block">
    <div class="summary-title">PAYMENT</div>
    <mat-form-field style="width:100%">
      <mat-label>PAYER (IF DIFFERENT FROM PATIENT)</mat-label>
      <input matInput [(ngModel)]="payerName" [ngModelOptions]="{standalone: true}" autocomplete="off">
    </mat-form-field>
    <mat-form-field style="width:100%">
      <mat-label>METHOD</mat-label>
      <mat-select [(ngModel)]="paymentMethod" [ngModelOptions]="{standalone: true}">
        <mat-option value="CREDIT CARD">CREDIT CARD</mat-option>
        <mat-option value="CASH">CASH</mat-option>
        <mat-option value="CHECK">CHECK</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field style="width:100%" *ngIf="paymentMethod === 'CREDIT CARD'">
      <mat-label>SQUARE SOURCE ID</mat-label>
      <input matInput [(ngModel)]="sourceId" [ngModelOptions]="{standalone: true}" autocomplete="off">
    </mat-form-field>

    <div class="multi-invoice" *ngIf="openInvoiceList.length">
      <div class="summary-title">ALSO PAY</div>
      <mat-checkbox
        *ngFor="let invoice of openInvoiceList"
        [checked]="selectedInvoiceIds.includes('' + invoice._id)"
        (change)="toggleInvoice(invoice._id, $event)"
      >
        {{ formatInvoiceNumber(invoice.invoiceNumber) }} — ${{ formatMoney(invoice.financials?.balanceDue) }}
      </mat-checkbox>
      <p *ngIf="selectedInvoiceIds.length">Combined balance ${{ formatMoney(combinedBalance) }}</p>
    </div>

    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="busy || !canPay"
      (click)="payInFull()"
    >
      PAY IN FULL ${{ formatMoney(financials.balanceDue) }}
    </button>
    <mat-form-field style="width:100%">
      <mat-label>CUSTOM PAYMENT AMOUNT</mat-label>
      <span matPrefix>$&nbsp;</span>
      <input matInput [(ngModel)]="customAmount" [ngModelOptions]="{standalone: true}" autocomplete="off">
    </mat-form-field>
    <button mat-stroked-button type="button" [disabled]="busy || !canPay" (click)="payCustom()">
      TAKE CUSTOM PAYMENT
    </button>
  </div>

  <div class="payment-block">
    <button mat-button type="button" (click)="historyOpen = !historyOpen">
      {{ historyOpen ? 'HIDE' : 'SHOW' }} PAYMENT HISTORY
    </button>
    <div *ngIf="historyOpen">
      <p *ngIf="!events.length">No financial events yet.</p>
      <p *ngFor="let event of events">{{ eventLabel(event) }}</p>
    </div>
    <div class="ack-actions">
      <button mat-button type="button" (click)="printSummary()">PRINT ORDER SUMMARY</button>
      <button mat-button type="button" (click)="emailSummary()">EMAIL ORDER SUMMARY</button>
    </div>
  </div>

    </div>
    <div fxFlex="0 0 225px" class="financial-sidebar">
      <mat-card class="frame-pricing-box">
        <mat-card-content>
          <mat-form-field style="width:100%" *ngFor="let row of summaryRowList">
            <input
              matInput
              [placeholder]="row.label"
              [value]="formatMoney(row.value)"
              readonly
              autocomplete="off"
            >
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
          <div class="suggested-deposit" *ngIf="financials.balanceDue > 0">
            Suggested 50% deposit ${{ formatMoney(financials.suggestedDeposit) }}
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card class="frame-pricing-box">
        <mat-card-content>
          <mat-form-field style="width:100%">
            <mat-select
              placeholder="TYPE"
              [(ngModel)]="otherCreditType"
              [ngModelOptions]="{standalone: true}"
            >
              <mat-option value="Frame Credit">Frame Credit</mat-option>
              <mat-option value="Lens Credit">Lens Credit</mat-option>
              <mat-option value="Frame + Lens Credit">Frame + Lens Credit</mat-option>
              <mat-option value="Return Credit">Return Credit</mat-option>
              <mat-option value="Restyle Credit">Restyle Credit</mat-option>
              <mat-option value="Custom Credit">Custom Credit Amount</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width:100%">
            <input
              matInput
              placeholder="AMOUNT"
              [(ngModel)]="otherCreditAmount"
              [ngModelOptions]="{standalone: true}"
              autocomplete="off"
            >
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
          <button
            mat-stroked-button
            class="sidebar-apply"
            type="button"
            [disabled]="busy || !orderId"
            (click)="applyOtherCredit()"
          >
            APPLY CREDIT
          </button>
          <mat-checkbox class="sidebar-pol" formControlName="pol">
            POL — PATIENT'S OWN LENSES
          </mat-checkbox>
          <mat-form-field style="width:100%" *ngIf="shippingControl">
            <input
              matInput
              placeholder="POSTAGE"
              [formControl]="shippingControl"
              autocomplete="off"
            >
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
